module.exports = __webpack_public_path__ + "a17d279f/img/menu-icon.5f8facae.svg";